import { createAuthenticatedApiClient } from '../../../shared/api/apiClient';
import { rpcCall } from '../../../shared/api/rpcClient';
import { useAuth } from '../../auth/context/AuthContext';
import { useMemo } from 'react';
import type { EscalationChain, EscalationLevel } from '../../../types';

export const createEscalationChainService = (idToken: string) => {
  const client = createAuthenticatedApiClient(idToken);

  return {
    getEscalationChain: async (customerId: string): Promise<EscalationChain> => {
      return rpcCall<EscalationChain>(client, 'customers.GetEscalationChain', { customer_id: customerId });
    },

    updateEscalationChain: async (customerId: string, levels: EscalationLevel[]): Promise<EscalationChain> => {
      return rpcCall<EscalationChain>(client, 'customers.UpdateEscalationChain', {
        customer_id: customerId,
        levels,
      });
    },
  };
};

export const useEscalationChainService = () => {
  const { idToken } = useAuth();

  return useMemo(() => {
    if (!idToken) {
      throw new Error('Not authenticated');
    }

    return createEscalationChainService(idToken);
  }, [idToken]);
};
